import { combineReducers } from 'redux';
import contentRecruiterActivity from './recruiter-activity-reducer';

const recruiterActivityReducer = combineReducers({
  contentRecruiterActivity,
});

export default recruiterActivityReducer;
